// 网站中英文翻译
import zhCN from './zh-CN'
import enUS from './en-US'

const messages = {
  'zh-CN': {
    ...zhCN
  },
  'zh-cn': {
    ...zhCN
  },

  // 英文版
  'en-US': {
    ...enUS
  },
  'en-GB': {
    ...enUS
  },
  'en': {
    ...enUS
  }
}
export default messages
